/**
 * The Scroll organic symbol mark and lockup.
 *
 * Symbol: organic S-scroll shape, viewBox 0 0 683.06 821.32.
 * Lockup: symbol + "scroll" wordmark with size-specific spacing specs.
 */
import type React from "react";

const SYMBOL_VIEWBOX = "0 0 683.06 821.32";
const SYMBOL_ASPECT = 821.32 / 683.06;

export const SYMBOL_PATH_A =
  "M682.11,571.36l-.74-7.66c-.25-3.54-1.26-7.93-1.73-11.41-1.17-6.29-2.79-12.52-4.45-18.7-14.26-51.45-53.52-88.4-103.03-106.26-16.6-6.51-42.02-11.33-59.47-15.59-19.97-4.56-39.99-9.04-59.65-14.83-9.78-2.95-19.51-6.28-28.86-10.44-37.6-16.88-65.3-52.04-75.3-91.78-4.62-19.19-6.02-39.56-4.38-59.9.06-.7.12-1.4.18-2.1.04-.41.07-.81.11-1.22.07-.7.14-1.4.21-2.1.06-.58.13-1.15.19-1.73.06-.49.11-.98.17-1.47,7.21-58.86,39.67-116.03,92.66-142.13,27.62-13.62,60.27-16.11,89.63-6.84,23.27,7.19,44.26,20.65,62.12,37.05,19.25,18.69,31.96,44.43,32.94,71.42.65,19.15-5.05,38.55-16.27,54.11-6.6,9.36-15.21,17.47-24.91,23.57-19.49,12.47-39.8,3.82-56.07-9.6-23.85-19.5-42.37-44.49-62.56-67.55-8.21-9.83-17.38-19.04-28.55-25.5-6.56-4-13.85-7.13-21.61-7.52-22.02-1.59-38.07,15.9-46.19,34.62-6.99,16.56-7.51,35.72-1.6,52.68l1.24,3.64,1.53,3.53.77,1.76c.25.59.51,1.18.83,1.73l1.82,3.39.91,1.7c.33.55.69,1.08,1.03,1.62,1.51,2.37,2.49,4,4.33,6.36l2.32,3.07s2.53,2.9,2.53,2.9c12.72,14.46,29.81,24.75,47.98,30.86,31.76,10.24,66.27,11.25,98.69,3.49,26.24-6,51.5-18.28,71.72-35.46.18-.15.36-.3.53-.45.26-.22.52-.45.78-.68,9.25-8.01,17.34-17.03,23.92-26.92.05-.08.1-.16.16-.24.4-.6.79-1.21,1.18-1.81.25-.39.49-.77.73-1.16.11-.18.23-.37.34-.55,13.03-21.14,19.44-46.1,15.62-73.7-2.04-15.27-6.97-30.04-13.65-43.88-6.23-10.71-13.62-20.72-21.94-29.9-1.97-2.13-4.01-4.2-6.07-6.24-15.96-15.97-34.92-29.24-55.89-40.14-.45-.23-.9-.47-1.35-.7-.87-.45-1.74-.89-2.62-1.33C486.96,13.47,419,1.9,354.61.65c-23.26-.52-45.9.33-67.09,2.25-.55.05-1.09.1-1.63.15-.96.09-1.92.18-2.87.27-1.26.12-2.52.26-3.79.39-5.6.59-11.09,1.27-16.45,2.01-1.15.15-2.29.3-3.43.46-.81.12-1.63.26-2.44.39-.71.11-1.44.21-2.14.32-18.89,3.09-37.79,7.46-56.2,13.32-.1.03-.2.06-.3.09-1.41.45-2.81.91-4.21,1.38-.34.11-.68.23-1.03.34-1.34.45-2.68.91-4.02,1.38-.36.13-.72.25-1.09.38-1.37.49-2.74.98-4.1,1.48-.26.1-.52.19-.78.29-31.6,11.75-61.23,28.3-86.17,50.91-.28.26-.57.51-.85.77-1.18,1.08-2.35,2.18-3.51,3.29-.42.4-.85.8-1.26,1.21-1.19,1.15-2.36,2.33-3.52,3.51-.29.29-.58.58-.86.87-.22.23-.45.45-.67.68-.7.74-1.39,1.49-2.08,2.24-40.46,43.32-62.6,103.17-59.21,162.95,4.27,90.25,62.43,171.17,149.65,198.62,19.75,5.99,40.47,11.35,60.34,16.05,59.11,14.19,123.05,25.97,175.6,56.76,7.01,4.2,14.02,8.83,20.56,13.75,42.94,31.46,70.23,84.31,70.77,137.83.01,13.33-1.54,26.66-5.09,39.48-2.49,9.44-6.4,18.63-12.05,26.48-6.67,9.23-15.44,17.26-26.28,21.29-22.17,8.19-48.23,1.04-67.67-11.94-29.23-19.68-48.4-50.35-66.4-80.12-4.44-7.74-9.36-15.14-16.22-21.34-3.01-2.66-6.59-5.29-11.38-7.1-10.28-3.96-21.19-.09-28.13,8.05-12.27,14.01-15.15,33.99-12.17,51.57,5.38,32.61,25.11,61.63,50.89,81.54,20.25,15.58,43.61,26.78,68.36,32.85,24.53,5.62,50.1,6.41,74.97,3.13,24.74-3.3,49-10.32,71.52-20.99,14.01-6.73,27.97-13.51,41.34-21.39,5.22-3.38,10.07-7.26,15.11-10.86,7.67-5.21,15.25-10.7,22.26-16.79,14.21-12.01,26.62-26.06,37.47-41.15,1.8-2.67,4.7-6.66,6.58-9.48,1.17-1.94,5.03-7.81,6.17-9.75,6.44-10.99,12.55-22.5,17.16-34.38,2.04-4.69,4.2-11.45,5.85-16.28,1.11-4.28,2.61-8.66,3.49-13,0,0,1.65-7.51,1.65-7.51.71-3.52,1.19-7.88,1.86-11.39.32-3.8.86-7.66,1.11-11.49.05-3.8.4-7.39.34-11.53-.18-3.71-.1-7.79-.44-11.53ZM476.61,309.37c-.18,0-.36-.02-.53-.03.18,0,.36.02.53.03ZM472.8,309.14c-.19-.01-.38-.02-.56-.04.19.01.38.02.56.04ZM513.19,28.68c-34.53-13.04-72.52-20.99-110.44-24.99,37.83,3.84,75.62,11.65,110.44,24.99ZM516.63,30.01c-.67-.26-1.33-.53-2.01-.78.67.26,1.34.52,2.01.78Z";

export const SYMBOL_PATH_B =
  "M267.94,580.73c5.64-1.5,11.54-1.83,17.32-1.15,11.93,1.4,23.18,6.84,32.59,14.15,2.94,2.28,5.71,4.76,8.31,7.42,22.8,23.33,28.34,51.15,46.26,71.15,2.07,2.31,7.44,2.05,9.66,1.43,2.61-.73,4.42-3.58,5.6-6.73,8.44-22.46.38-51.37-14.85-69.55-69.6-74.17-223.11-48.09-305.38-7.92-110.55,54-74.74,187.4,38.31,207.59,45.97,8.63,91.37-10.6,102.48-58.85,7.32-31.62,3.08-60.22,10.28-93.41,2.34-10.8,6.05-21.42,11.28-31.17,3.02-5.63,6.57-11.02,10.88-15.76,4.53-4.97,9.88-8.74,15.68-12.08,3.69-2.13,7.45-4,11.57-5.13Z";

interface ScrollSymbolProps {
  size?: number;
  color?: string;
  className?: string;
}

export function ScrollSymbol({ size = 28, color = "currentColor", className = "" }: ScrollSymbolProps) {
  const height = size * SYMBOL_ASPECT;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={SYMBOL_VIEWBOX}
      width={size}
      height={height}
      className={className}
      aria-hidden="true"
    >
      <path d={SYMBOL_PATH_A} fill={color} />
      <path d={SYMBOL_PATH_B} fill={color} />
    </svg>
  );
}

// Lockup presets matching the spec table
type LockupPreset = "billboard" | "marketing" | "header" | "nav" | "footer" | "watermark" | "stacked";

export const SCROLL_LOCKUP_SPECS: Record<LockupPreset, {
  symbol: number;
  wordmark: number;
  tracking: number;
  gap: number;
  drop: number;
  opacity?: number;
  stacked?: boolean;
}> = {
  billboard: { symbol: 80, wordmark: 72, tracking: -2.0, gap: 14, drop: 4 },
  marketing: { symbol: 48, wordmark: 44, tracking: -1.0, gap: 10, drop: 3 },
  header: { symbol: 28, wordmark: 24, tracking: -0.5, gap: 8, drop: 0 },
  nav: { symbol: 20, wordmark: 18, tracking: -0.3, gap: 6, drop: 0 },
  footer: { symbol: 14, wordmark: 13, tracking: 0, gap: 4, drop: 0 },
  watermark: { symbol: 16, wordmark: 14, tracking: -0.3, gap: 5, drop: 0, opacity: 0.7 },
  stacked: { symbol: 64, wordmark: 28, tracking: -0.8, gap: 12, drop: 0, stacked: true },
};

interface ScrollLockupProps {
  preset?: LockupPreset;
  color?: string;
  className?: string;
  symbolSize?: number;
}

export function ScrollLockup({ preset = "header", color = "currentColor", className = "", symbolSize }: ScrollLockupProps) {
  const spec = SCROLL_LOCKUP_SPECS[preset];
  const layout = spec.stacked ? "flex-col items-center" : "items-center";

  const wordmarkStyle: React.CSSProperties = {
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    fontWeight: 800,
    fontSize: spec.wordmark,
    letterSpacing: spec.tracking,
    lineHeight: 1,
    color,
    transform: spec.drop ? `translateY(${spec.drop}px)` : undefined,
  };

  return (
    <div
      className={`flex ${layout} ${className}`}
      style={{ gap: spec.gap, opacity: spec.opacity }}
    >
      <ScrollSymbol size={symbolSize ?? spec.symbol} color={color} />
      <span style={wordmarkStyle}>scroll</span>
    </div>
  );
}

// Default export for backward compatibility
export default ScrollSymbol;
